import { render, staticRenderFns } from "./sonChiose.vue?vue&type=template&id=4a1872b2&scoped=true&"
import script from "./sonChiose.vue?vue&type=script&lang=js&"
export * from "./sonChiose.vue?vue&type=script&lang=js&"
import style0 from "./sonChiose.vue?vue&type=style&index=0&id=4a1872b2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a1872b2",
  null
  
)

export default component.exports